import { Link } from 'react-router-dom';

const HowItWorks = ({ content }) => {
  // Add debug logging in development only
  if (import.meta.env.DEV) {
    console.log('HowItWorks received content:', content);
  }
  
  // Default values as fallback if content is not provided
  const {
    title = "Get started in",
    subtitle = "3 simple steps",
    description = "Creating your link-in-bio page takes just minutes. Here's how it works.",
    ctaText = "Start Building Your Page",
    ctaLink = "/signup",
    steps = [
      {
        id: "step-1",
        number: '01',
        title: 'Sign Up',
        description: 'Create your free account in seconds. No credit card required.',
      },
      {
        id: "step-2",
        number: '02',
        title: 'Customize',
        description: 'Add your links, upload images, and personalize your page design.',
      },
      {
        id: "step-3",
        number: '03',
        title: 'Share',
        description: 'Get your unique URL and share it everywhere - social media, email, anywhere!',
      },
    ]
  } = content || {};

  if (import.meta.env.DEV) {
    console.log('HowItWorks steps being rendered:', steps);
  }

  return (
    <section id="how-it-works" className="py-20 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16 animate-fade-in">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            {title}{' '}
            <span className="bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent">
              {subtitle}
            </span>
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            {description}
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 relative">
          {/* Connection line for desktop */}
          <div className="hidden md:block absolute top-1/2 left-0 right-0 h-0.5 bg-gray-200 -translate-y-1/2 z-0"></div>
          
          {steps.map((step, index) => {
            // Ensure each step has a number, defaulting to the 1-based index
            const stepNumber = step.number || (index + 1).toString().padStart(2, '0');
            if (import.meta.env.DEV) {
              console.log(`Rendering step ${index}:`, step, 'number:', stepNumber);
            }
            return (
              <div key={step.id || index} className="relative z-10 animate-scale-in" style={{ animationDelay: `${index * 200}ms` }}>
                <div className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow duration-300">
                  <div className="w-16 h-16 bg-gradient-to-r from-purple-600 to-pink-600 rounded-full flex items-center justify-center text-white text-2xl font-bold mb-4 mx-auto">
                    {stepNumber}
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-2 text-center">{step.title}</h3>
                  <p className="text-gray-600 text-center">{step.description}</p>
                </div>
              </div>
            );
          })}
        </div>

        <div className="text-center mt-12">
          <Link
            to={ctaLink}
            className="inline-block button-gradient text-white px-8 py-4 rounded-lg text-lg font-semibold transform hover:scale-105 transition-transform"
          >
            {ctaText}
          </Link>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;